import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetParmConfig, //寄送，支付接口
} from '@api/commonApi.js';
export default {
    methods: {
        /*支付，寄送*/
        getPay(type) {
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ParmType: type
            }
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 9) {
                        this.PayList = res.data.Data;
                    } else {
                        this.transportList = res.data.Data;
                    }

                });
            });
        },
        // 查看/修改获取单条
        getList(orderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: orderId
            };
            this.GoodsListNum = []
            this.ListData = []
            $http.get("api/MeetOrder/GetMeetLinkOrderByIdEx", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {

                    this.form = util.filterAndSetData(this.form, Data) //过滤数据
                    this.TotalPrice = Data.TotalPrice
                    console.log(this.TotalPrice)
                    // 代理商主联系人，代理商公司，代理商所在区域，代理商联系电话
                    this.agent = Data.C_Name + '  ' + Data.AgentName + '  ' + Data.ShortAddress + '  ' + Data.C_Tel
                    //园所名称，园长姓名及园长电话
                    this.school = Data.SchoolName + '  ' + Data.PrincipalName + '  ' + Data.PrincipalPhoneNo
                    this.ConsigneeList = Data.SchoolProvName + '  ' + Data.SchoolCityName + '  ' + Data.SchoolAreaName + '  ' + Data.SchoolAddress //收货地址
                    this.ConsigneeListName = Data.SchoolConsignee + '  ' + Data.SchoolConsigneeTel //联系人及电话


                    // if (Data.PackageId == 1008) {
                    //     this.GoodsListNum = cloneDeep(Data.GoodsList)
                    //     this.ListData = cloneDeep(Data.GoodsList) //1008套餐存储数据下发的
                    // } else {
                    //     //D套餐
                    //     for (let i = 0; i < Data.GoodsList.length; i++) {
                    //         for (let j = 0; j < this.packagesD.length; j++) {
                    //             if (Data.GoodsList[i].ProId == this.packagesD[j].ProId) {
                    //                 this.packagesD[j].ProNum = Data.GoodsList[i].ProNum
                    //             }
                    //         }

                    //     }
                    // }
                    // 获取资源包数据
                    for (let i = 0; i < Data.GoodsList.length; i++) {
                        for (let j = 0; j < this.packagesD.length; j++) {
                            if (Data.GoodsList[i].ProId == this.packagesD[j].ProId) {
                                this.packagesD[j].ProNum = Data.GoodsList[i].ProNum
                            }
                        }

                    }
                    for (let i = 0; i < Data.GiftList.length; i++) {
                      for (let j = 0; j < this.packageZ.length; j++) {
                          if (Data.GiftList[i].ProId == this.packageZ[j].ProId) {
                              this.packageZ[j].ProNum = Data.GiftList[i].ProNum
                          }
                      }

                  }
                    this.form.Remark = Data.OrderRemark
                    this.PackageName = Data.PackageName
                    this.payList = cloneDeep(Data.PayList)
                    this.PayListData = cloneDeep(Data.PayList)

                    if (Data.PackageId == 10082) {
                        this.GetSchoolDebtAll(Data.SchoolId, Data.OrderId)
                    }

                });
            });
        },
        // 获取收货地址
        getSchoolConsigneeList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                schoolId: id
            };

            $http.get("api/School/GetSchoolConsigneeList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.SchoolConsigneeList = Data;
                    for (let i = 0; i < this.SchoolConsigneeList.length; i++) {
                        //IsDefault==1为默认地址

                        if (this.SchoolConsigneeList[i].IsDefault == 1) {

                            this.ConsigneeList = this.SchoolConsigneeList[i].ConsigneeProvinceName + '  ' + this.SchoolConsigneeList[i].ConsigneeCityName + '  ' + this.SchoolConsigneeList[i].ConsigneeAreaName + '  ' + this.SchoolConsigneeList[i].ConsigneeAdress
                            this.ConsigneeListName = this.SchoolConsigneeList[i].Consignee + '  ' + this.SchoolConsigneeList[i].ConsigneeTel
                            this.form.SchoolConsigneeId = this.SchoolConsigneeList[i].Id

                            //设置地址
                            this.form.ConsigneeProvId = this.SchoolConsigneeList[i].ConsigneeProvince
                            this.form.ConsigneeCityId = this.SchoolConsigneeList[i].ConsigneeCity
                            this.form.ConsigneeAreaId = this.SchoolConsigneeList[i].ConsigneeArea
                            this.form.ConsigneeAddress = this.SchoolConsigneeList[i].ConsigneeAdress
                            this.form.Consignee = this.SchoolConsigneeList[i].Consignee
                            this.form.ConsigneeTel = this.SchoolConsigneeList[i].ConsigneeTel


                        }
                    }
                });
            });
        },
        //会销开课 新增转园开课（IsTransfer=1 OldSchoolId必传 ）
        getAddOrderList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            if (this.isSchoolKaike) {
                this.form.IsTransfer = 1
                this.form.OldSchoolId = this.OldSchoolId
            }

            $http.post("api/MeetOrder/MeetPassOrderAddEx", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {

                    let msg = ''
                    if (this.form.PackageId == 10082) {
                        msg = '续订成功'
                    } else if (this.isSchoolKaike) {
                        msg = '转园开课成功'
                    } else {
                        msg = '开课成功'
                    }
                    this.$notify({
                        title: '成功',
                        message: msg,
                        type: 'success'
                    });
                    this.$emit('getTableList')
                    this.AddDialogVisible = false
                    if (this.form.PackageId !== 10082) {
                        // 开课跳转
                        this.$router.push("/Order/SchoolOrder/MeetOpenClassOrder");
                    }
                    this.initData();
                });
            });
        },

        //会销相关订单修改提交
        getUpdateOrderList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            $http.post("api/MeetOrder/MeetOrderLinkUpdate", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    });

                    this.AddDialogVisible = false
                });
            });
        },
        // 根据套餐ID和园所ID获取开课情况  （转会销开课需要传AgentId）
        getSchoolOpenInfo(schoolId, packageId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: schoolId,
                PackageId: packageId,
            };
            if (this.isKaike) {
                params.AgentId = this.form.AgentId
            }
            $http.get("api/MeetOrder/GetSchoolOpenInfoByPackageId", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    let PackageName = ''
                    if (packageId == 1008) {
                        PackageName = "2017Q4会销"
                    } else if (packageId == 10081) {
                        PackageName = "E1套餐升级开课"
                    } else {
                        PackageName = "D套餐开课"
                    }

                    if (Data.SurplusOpenClassNum === 0) {
                        if (this.isKaike) {
                            this.$notify({
                                title: '警告',
                                message: '该代理商暂无可开课班级数',
                                type: 'warning'
                            });
                        } else {
                            this.$notify({
                                title: '警告',
                                message: '该园所暂无' + PackageName + '套餐可开课班级数',
                                type: 'warning'
                            });
                        }

                    }

                    this.showData.ClassNum = Data.ClassNum
                    this.showData.OpenClassNum = Data.OpenClassNum
                    this.showData.lessClassNum = Data.SurplusOpenClassNum
                });
            });
        },
        // 判断精装简装
        getMeetPackageTypeList(schoolId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: schoolId,
            };

            $http.get("api/MeetOrder/MeetPackageTypeList", params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    if (Data.JianZhuanNum > 0) {
                        this.JianZ = false
                    } else if (Data.JianZhuanNum == 0) {
                        this.JianZ = true
                    }
                    if (Data.JingZhuanNum > 0) {
                        this.JingZ = false
                    } else if (Data.JingZhuanNum == 0) {
                        this.JingZ = true
                    }

                });
            });
        },
        // 获取未提货资源包 (只有续订资源包调用)
        GetSchoolDebtAll(schoolId, OrderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: schoolId,
                OrderId: OrderId
            };

            $http.get("api/School/GetSchoolDebtAll", params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.debtPackage.HiDebtInfo = Data.HiDebtInfo.Total
                    this.debtPackage.BookHiData = Data.BookHiData.Total
                    this.debtPackage.FreePostData = Data.FreePostData.Total

                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/addOrderDialog/services.js